import sorters from "../../util/sorters";
import moment from "moment/moment";
import {PREFERRED_DATETIME_FORMAT} from "../../util/time";
import {Row, Table} from "antd";
import {UnfoundProjectButton} from "./UnfoundProjectButton";
import {RemoveUnfoundProjectButton} from "./RemoveUnfoundProjectButton";
import {getPaginationConfig} from "../../util/showAllPagination";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";
import {useRef} from "react";


const UnfoundProjectsTable = ({
                                unfoundProjects,
                                loading,
                                permissions,
                                user,
                                handleUnfoundProjectResponse,
                              }) => {
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);

  const columns = [
    {
      title: 'Project Code',
      dataIndex: 'projectCode',
      sorter: (a, b) => sorters.string(a.projectCode, b.projectCode)
    },
    {
      title: 'Action',
      dataIndex: 'action',
      sorter: (a, b) => sorters.string(a.action, b.action)
    },
    {
      title: 'Mapping',
      dataIndex: 'mapProjectCode',
      sorter: (a, b) => sorters.string(a.mapProjectCode, b.mapProjectCode)
    },
    {
      title: 'Updated By',
      dataIndex: 'updatedByEmail',
      sorter: (a, b) => sorters.string(a.updatedByEmail, b.updatedByEmail)
    },
    {
      title: 'Updated At',
      dataIndex: 'UpdatedAt',
      width: 165,
      sorter: (a, b) => sorters.date(a.UpdatedAt, b.UpdatedAt),
      render: i => i ? moment.utc(i).local().format(PREFERRED_DATETIME_FORMAT) : '-'
    }, {
      title: 'Action',
      width: 220,
      hidden: permissions === null,
      render: h => (
        <>
          {permissions !== null && permissions.canManageExpenses &&
            (
              <>
                <Row>
                  <UnfoundProjectButton
                    disabled={loading}
                    isEdit={true}
                    title={"Edit"}
                    email={user.email}
                    onCompleted={handleUnfoundProjectResponse}
                    record={h}
                    style={{marginRight: 10}}
                  />
                  <RemoveUnfoundProjectButton
                    id={h.ID}
                    email={user.email}
                    onCompleted={handleUnfoundProjectResponse}
                  />
                </Row>
              </>
            )
          }
        </>
      )
    }
  ].filter(item => !item.hidden);
  return (
    <>
      <Table
        ref={tableContainerRef}
        rowKey="ID"
        dataSource={unfoundProjects}
        columns={columns}
        pagination={getPaginationConfig(unfoundProjects.length)}
        size="small"
        loading={loading}
        scroll={{y: tableHeight}}
      />
    </>
  );
};

export {UnfoundProjectsTable};